import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import type { SpecialtyCountry } from "../constants/specialtyCountries";

export interface Specialty {
  id: string;
  name: string;
  country: SpecialtyCountry;
}

export const specialtiesApi = {
  /**
   * Fetch all specialties from the `specialties` Firestore collection.
   * Each document must have a `name` field with the display label (e.g. "Dentist").
   * `country` falls back to "AU" for legacy docs created before the field existed
   * (matches the same fallback in functions/.../listSpecialties.js).
   */
  getSpecialties: async (): Promise<Specialty[]> => {
    const snap = await getDocs(collection(db, "specialties"));
    return snap.docs
      .map((d) => ({
        id: d.id,
        name: d.data().name as string,
        country: (d.data().country as SpecialtyCountry) || "AU",
      }))
      .filter((s) => !!s.name)
      .sort((a, b) => a.name.localeCompare(b.name));
  },
};
